import { ClockCircleOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import styles from './index.module.scss';

const { wrapper, small } = styles;
interface TimeProps {
  value?: string,
  className?: string,
  showUTC?: boolean
}

function Time({ value, className, showUTC = true } : TimeProps) {
  return (
    <div className={`${wrapper}${className ? ` ${className}` : ''}`}>
      <ClockCircleOutlined />
      <Typography.Text>{value || '--:--:--'}</Typography.Text>
      {showUTC && value && <Typography.Text className={small} type="secondary">UTC</Typography.Text>}
    </div>
  );
}

export default Time;
